import {match} from 'ts-pattern';

import type {BulkOperationState} from '../types/api/bulkOperations';

export function isBulkOperationTerminal(state: BulkOperationState) {
  return match(state)
    .with('PENDING', 'IN_PROGRESS', () => false)
    .with('DONE', 'PARTIALLY_DONE', 'FAILED', 'RESOLVE_FAILED', () => true)
    .exhaustive();
}
